import { Send } from "lucide-react";
import { useLeadModal } from "@/context/LeadModalContext";
import Reveal from "@/components/landing/Reveal";

const TEAM_PHOTO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_algo-profits-4/artifacts/3owtj5cr_photo_2024-11-26_20-39-03.jpg";

export default function AboutUs() {
  const { openModal } = useLeadModal();

  return (
    <section
      id="chi-siamo"
      data-testid="about-us-section"
      className="relative py-20 sm:py-28"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        {/* Header — above the photo */}
        <Reveal>
          <div className="mb-10 text-center sm:mb-12">
            <div className="mb-4 inline-flex items-center gap-2">
              <span className="h-px w-8 bg-gradient-to-r from-transparent to-yellow-400" />
              <span className="font-heading text-[11px] font-bold uppercase tracking-[0.3em] text-yellow-300">
                Chi Siamo
              </span>
              <span className="h-px w-8 bg-gradient-to-l from-transparent to-yellow-400" />
            </div>
            <h2
              data-testid="about-us-title"
              className="font-heading text-3xl font-black uppercase leading-[1] tracking-tight text-white sm:text-4xl lg:text-5xl"
            >
              Due ragazzi, <span className="text-gradient-gold">una missione</span>
            </h2>
          </div>
        </Reveal>

        {/* Photo */}
        <Reveal delay={80}>
          <div
            data-testid="about-us-photo-wrapper"
            className="relative mx-auto max-w-xl overflow-hidden rounded-[28px] border border-yellow-400/25"
            style={{ boxShadow: "0 0 50px rgba(255,215,0,0.12)" }}
          >
            <img
              src={TEAM_PHOTO_URL}
              alt="Antonio e Carlo, fondatori di TheGoldFx"
              data-testid="about-us-photo"
              loading="lazy"
              className="h-full w-full object-cover"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#050505]/70 via-transparent to-transparent" />
            <div className="pointer-events-none absolute inset-0 bg-grid-pattern opacity-20" />
          </div>
        </Reveal>

        {/* Copy — below the photo */}
        <Reveal delay={160}>
          <p
            data-testid="about-us-text"
            className="mx-auto mt-8 max-w-2xl text-center font-body text-base leading-relaxed text-gray-300 sm:text-lg"
          >
            TheGoldFx nasce dall&apos;idea di due semplici ragazzi ambiziosi (
            <span className="font-semibold text-white">Antonio e Carlo</span>) con una sfrenata
            passione per il trading. Da quell&apos;idea è nato un progetto che oggi vanta un{" "}
            <span className="font-semibold text-cyan-300">team di 50 professionisti dal 2020</span>
            . Abbiamo creato <span className="font-semibold text-yellow-300">Aurum AI</span> per
            darti la nostra tecnologia e restituirti il tuo tempo.
          </p>

          <div className="mt-8 flex justify-center">
            <button
              type="button"
              onClick={openModal}
              data-testid="about-us-cta"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-yellow-300 via-yellow-400 to-yellow-600 px-7 py-4 font-heading text-sm font-black uppercase tracking-wider text-black shadow-[0_0_30px_rgba(255,215,0,0.45)] transition-all duration-300 hover:scale-[1.03] hover:shadow-[0_0_50px_rgba(255,215,0,0.7)] sm:text-base"
            >
              <Send className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              Richiedi informazioni
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
